import { Chip } from './Chip';

export type TournamentCardTone = 'live' | 'soon' | 'archive';

export interface TournamentCardProps {
  id: string;
  name: string;
  meta?: string;
  tone: TournamentCardTone;
  href?: string;
  className?: string;
}

const TONE_BG: Record<TournamentCardTone, string> = {
  live: 'bg-primary-soft',
  soon: 'bg-background',
  archive: 'bg-background',
};

export function TournamentCard({
  id, name, meta, tone, href, className,
}: TournamentCardProps) {
  const inner = (
    <div className={[
      'border border-border rounded p-4',
      TONE_BG[tone],
      className,
    ].filter(Boolean).join(' ')}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-[10.5px] text-foreground-muted tracking-[0.06em]">{id}</span>
        {tone === 'live'    && <Chip tone="accent" className="!px-1.5 !py-0.5 !text-[9.5px]">live</Chip>}
        {tone === 'soon'    && <Chip tone="clay"   className="!px-1.5 !py-0.5 !text-[9.5px]">скоро</Chip>}
        {tone === 'archive' && <Chip tone="outline" className="!px-1.5 !py-0.5 !text-[9.5px]">архив</Chip>}
      </div>
      <div className="font-serif text-[22px] mt-1.5 tracking-[-0.01em]">{name}</div>
      {meta && <div className="text-xs text-foreground-soft mt-1">{meta}</div>}
    </div>
  );

  if (href) {
    return (
      <a href={href} className="block no-underline text-inherit">
        {inner}
      </a>
    );
  }
  return inner;
}
